module.exports = __webpack_public_path__ + "static/media/36x36-9.df7b483c.png";